import React from 'react'

export default function Completed ({ fontsize = '' }: { fontsize?: string | undefined }): JSX.Element {
    return <div className={`badge badge-light-success border border-success ${fontsize}`}>Completed</div>
}
